var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.992,
    height: 11.994,
    viewBox: "0 0 15.992 11.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-eye",
    "data-name": "Icon feather-eye",
    transform: "translate(0 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M8,4.5a7.053,7.053,0,0,1,3.435.916A10.109,10.109,0,0,1,13.9,7.376,13.239,13.239,0,0,1,15.922,10.2a.666.666,0,0,1,0,.6A13.239,13.239,0,0,1,13.9,13.618a10.109,10.109,0,0,1-2.465,1.96A7.053,7.053,0,0,1,8,16.494a7.053,7.053,0,0,1-3.435-.916A10.109,10.109,0,0,1,2.1,13.618,13.239,13.239,0,0,1,.07,10.8a.666.666,0,0,1,0-.6A13.239,13.239,0,0,1,2.1,7.376a10.109,10.109,0,0,1,2.465-1.96A7.053,7.053,0,0,1,8,4.5Zm6.569,6A12.5,12.5,0,0,0,12.9,8.262,6.746,6.746,0,0,0,8,5.833C4.4,5.833,2.049,9.425,1.427,10.5a12.5,12.5,0,0,0,1.665,2.235A6.746,6.746,0,0,0,8,15.161C11.591,15.161,13.943,11.569,14.565,10.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M14.665,12A2.665,2.665,0,1,1,12,14.665,2.668,2.668,0,0,1,14.665,12Zm0,4a1.333,1.333,0,1,0-1.333-1.333A1.334,1.334,0,0,0,14.665,16Z",
    transform: "translate(-6.669 -4.168)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.afa547fdebf9019dd21703a8507d1e68.svg";
export { ForwardRef as ReactComponent };